<template>
  <mdc-dialog v-model="isOpen"
              class="auto_height_modal"
              :title="'protocol.setup_stimuli', {title: stimul.description}  | trans"
              :accept="'user.save' | trans"
              :cancel="'user.cancel' | trans"
              :accept-disabled="disabled"
              @accept="save"
              @cancel="close">
    <div class="close-cross" @click="close()">
      <mdc-icon icon="close"></mdc-icon>
    </div>
    <loader v-if="!isLoaded" class="table-loader"></loader>
    <form enctype="multipart/form-data" novalidate>
      <div class="form-group row">
      <div class="col-12">
        <v-select v-model="phaseTask"
                  :options="phases"
                  name="phases"
                  label="title"
                  :filterable="false"
                  :class="{'is-invalid': errors.has('phaseTask'), 'is-clear': !phaseTask}"
                  v-validate="'required'"
                  data-vv-validate-on="none"
                  :data-vv-as="'protocol.choose_phase' | trans">
        </v-select>
        <label class="mdc-floating-label" v-if="currentPhase">{{currentPhase}}</label>
      </div>
    </div>

      <div class="form-group row" v-if="fieldList && phaseTask">
        <div class="col-12" v-if="phaseTask.typeId != 3">
          <mdc-select v-model="field"
                      :label="'protocol.choose_field' | trans"
                      name="field"
                      :class="{'is-invalid': errors.has('field'), 'is-full': field}"
                      data-vv-validate-on="none"
                      :data-vv-as="'protocol.choose_field' | trans">
            <option v-for="item in fieldList" :value="item">
              {{'protocol.field' | trans}} {{item}}
            </option>
          </mdc-select>
        </div>
      </div>

      <div class="form-group row" v-if="intervalList && phaseTask">
        <div class="col-12" v-if="phaseTask.typeId == 3">
          <mdc-select v-model="interval"
                      :label="'protocol.choose_interval' | trans"
                      name="interval"
                      :class="{'is-invalid': errors.has('interval'), 'is-full': interval}"
                      data-vv-validate-on="none"
                      :data-vv-as="'protocol.choose_interval' | trans">
            <option v-for="item in intervalList" :value="item.typeId">
               {{item.name}}
            </option>
          </mdc-select>
        </div>
      </div>

    </form>

  </mdc-dialog>


</template>

<script>
  import {Validator} from 'vee-validate';
  import Loader from '../../loader/components/Loader';
  import filter from 'lodash/filter';
  import lang from '../../../lang/translator';
  import forEach from 'lodash/forEach';
  import findIndex from 'lodash/findIndex';
  import toInteger from 'lodash/toInteger';


  export default {
    name: 'TaskDTTModal',
    props: {
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'data': {
        type: [Object,Array],
        default() {
          return null;
        },
      },
      'stimul': {
        type: [Object,Array],
        default() {
          return {};
        },
      },
      'intervals': {
        type: [Object,Array],
        default() {
          return {};
        },
      },
    },
    components: {
      Loader,
    },

    computed: {
      isOpen: {
        get(){
          return this.visible;
        },
        set() {},
      }
    },

    data() {
      return {
        isLoaded: true,
        disabled: false,
        phases: [],
        phaseTask: null,
        field: null,
        fieldList: null,
        interval: null,
        intervalList: null,
        currentPhase: null,
      };
    },
    async mounted() {
      if(this.data){

        this.phases = filter(this.data, (item) =>{ return item.active; });
        let currentPhase = filter(this.data, (item) => { return item.typeId == this.stimul.phaseType; })[0];
        if (currentPhase.active){
          this.phaseTask = currentPhase;
          this.field = this.stimul.fieldIndex ? this.stimul.fieldIndex.toString() : '1';
        } else{
          //this.phaseTask = this.phases[0];
          this.currentPhase = currentPhase.title;
          this.disabled = true;
        }

        let phase = filter(this.data, function(item) {return item.typeId == 3; })[0];

        forEach(phase.intervals, (item) => {
          let index = findIndex(this.intervals, {
            typeId: item.type ? item.type.id : item.typeId
          });

          this.intervals[index].id = item.id
          this.intervals[index].phaseId = item.phaseId
          this.intervals[index].count = item.count.toString()
        });

        this.intervalList = filter(this.intervals, (item) => { return item.checked }) ;



      }
    },

    methods: {

      async save() {
        this.disabled = true;
        let result = await this.$validator.validateAll();
        if (!result) {
          this.disabled = false;
          return;
        }

        let phaseTypeId = this.phaseTask ? this.phaseTask.typeId : null;
        let interval = filter(this.intervalList, (item) => {return item.typeId == this.interval; })[0];
        let field = this.field;
        let label = this.fieldList ? this.fieldList[0] : null;
        field = this.field  ? this.field : label;


        this.$emit('save', phaseTypeId, field, interval);
      },

      close() {
        this.$emit('close');
      },
    },
    watch: {
      phaseTask: async function(val) {
        if (val) {
          let phase = filter(this.data, function(item) {return item.typeId == val.typeId; })[0];
          this.disabled = false;
          let fieldList = null;
          if (phase.minFieldCount && phase.withFields) {
            fieldList = [];
            let min = toInteger(phase.minFieldCount);
            let max = toInteger(phase.maxFieldCount);
            for (let i = min; i <= max; i++) {
              fieldList.push(i)
            }
          }
          if (phase.intervals) {
            let firstInterval = this.intervalList[0] ? this.intervalList[0].typeId.toString() : null;
            this.interval = this.stimul && this.stimul.intervalType ? this.stimul.intervalType.toString() : firstInterval;
          }

          this.fieldList = fieldList;
          let field = filter(fieldList, val => {return val == this.stimul.fieldIndex});
          let label = this.fieldList ? this.fieldList[0].toString() : null;
          this.field = this.stimul.fieldIndex && field.length > 0 ? this.stimul.fieldIndex.toString() : label;



        }
      },
    },

  };
</script>



// WEBPACK FOOTER //
// src/modules/protocols/components/TaskDTTModal.vue